<mat-sidenav-container class="sidenav-container">
  <mat-sidenav #drawer class="sidenav" [mode]="sidenavMode" [opened]="opened()">
    <div class="sidenav-inner">
      <div class="sidenav-header">
        GPT Admin Tool
        <button
          mat-icon-button
          (click)="toggleSidenav()"
          class="toggle-btn inside"
        >
          <mat-icon>menu</mat-icon>
        </button>
      </div>

      <ng-container *ngIf="!isLoading(); else skeleton">
        <ul>
          @for (item of navigationLinks(); track item) {
          <li>
            <button
              [routerLink]="item.url"
              class="nav-btn"
              routerLinkActive="active"
            >
              <div class="icon-container">
                <mat-icon>{{ item.icon }}</mat-icon>
              </div>
              <span>{{ item.label }}</span>
            </button>
          </li>
          }
        </ul>
      </ng-container>

      <ng-template #skeleton>
        <ul class="skeleton-list" aria-hidden="true">
          <li *ngFor="let i of skeletonItems" class="skeleton-item">
            <div class="skeleton-icon shimmer"></div>
            <div class="skeleton-text shimmer"></div>
          </li>
        </ul>
      </ng-template>
      <!-- <mat-nav-list>
        @for (item of navigationLinks(); track item) {
        <a\bu  [routerLink]="item.url" routerLinkActive="active" >
          <mat-icon>{{ item.icon }}</mat-icon>
          <span>{{ item.label }}</span>
        </a>
        }
      </mat-nav-list> -->
    </div>
  </mat-sidenav>

  <mat-sidenav-content>
    <div class="top-bar">
      <button
        *ngIf="!opened()"
        mat-icon-button
        (click)="toggleSidenav()"
        class="toggle-btn outside"
      >
        <mat-icon>menu</mat-icon>
      </button>
      <div class="spacer"></div>
      <div class="user-badge" *ngIf="coreStore.user()">
        <div class="user-avatar">{{ userInitials() }}</div>
        <span class="user-name">{{ coreStore.user()?.name }}</span>
      </div>
    </div>

    <div class="main-content">
      <app-breadcrumbs [items]="coreStore.breadcrumbs()"> </app-breadcrumbs>
      <router-outlet />
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
